"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFeather = require("react-feather");

require("./styles.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var supportedSocials = {
  document: _reactFeather.FileText,
  facebook: _reactFeather.Facebook,
  github: _reactFeather.GitHub,
  instagram: _reactFeather.Instagram,
  linkedin: _reactFeather.Linkedin,
  youtube: _reactFeather.Youtube
};

var SocialIcons = /*#__PURE__*/function (_React$Component) {
  _inherits(SocialIcons, _React$Component);

  var _super = _createSuper(SocialIcons);

  function SocialIcons() {
    _classCallCheck(this, SocialIcons);

    return _super.apply(this, arguments);
  }

  _createClass(SocialIcons, [{
    key: "render",
    value: function render() {
      var _this = this;

      var iconSize = this.props.size || 20;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.className || '', " socials")
      }, Object.keys(this.props).reduce(function (components, propName) {
        if (supportedSocials[propName]) {
          var Social = supportedSocials[propName];
          components.push( /*#__PURE__*/_react["default"].createElement("div", {
            className: "d-inline"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            className: "socialIcon",
            href: _this.props[propName],
            "aria-label": propName,
            target: "_blank",
            rel: "noreferrer"
          }, /*#__PURE__*/_react["default"].createElement(Social, {
            size: iconSize
          }))));
        }

        return components;
      }, []));
    }
  }]);

  return SocialIcons;
}(_react["default"].Component);

SocialIcons.propTypes = {
  document: _propTypes["default"].string,
  facebook: _propTypes["default"].string,
  github: _propTypes["default"].string,
  instagram: _propTypes["default"].string,
  linkedin: _propTypes["default"].string,
  youtube: _propTypes["default"].string,
  size: _propTypes["default"].number
};
var _default = SocialIcons;
exports["default"] = _default;